module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "amap-wrapper"
  }, [_c('el-amap', {
    staticClass: "amap-box",
    attrs: {
      "plugin": _vm.plugin,
      "vid": "map",
      "zoom": _vm.zoom,
      "center": _vm.center,
      "events": _vm.events
    }
  }, [_c('el-amap-search-box', {
    staticClass: "search-box",
    attrs: {
      "search-option": _vm.searchOption,
      "on-search-result": _vm.onSearchResult
    }
  }), _vm._v(" "), _c('el-amap-marker', {
    staticClass: "amap-marker",
    attrs: {
      "position": _vm.center,
      "vid": "marker",
      "label": _vm.label
    }
  })], 1), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.closeMap
    }
  }, [_c('i', {
    staticClass: "iconfont icon-close fs-14"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-complete",
    attrs: {
      "type": "button",
      "id": "submit-map",
      "validate": "true"
    },
    on: {
      "click": _vm.submitMap
    }
  }, [_vm._v("提交")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6f6be300","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/containers/DataTablePage/amapSelect.vue
// module id = 1776
// module chunks = 1